export var Name = 'checkout-step-changed';
export var CheckoutStepChangedEvent = Name;
export var CheckoutStep;

(function (CheckoutStep) {
  CheckoutStep[CheckoutStep["Basket"] = 1] = "Basket";
  CheckoutStep[CheckoutStep["Offers"] = 3] = "Offers";
  CheckoutStep[CheckoutStep["Delivery"] = 4] = "Delivery";
  CheckoutStep[CheckoutStep["Payment"] = 5] = "Payment";
  CheckoutStep[CheckoutStep["Review"] = 7] = "Review";
})(CheckoutStep || (CheckoutStep = {}));